import api from "../lib/apiClient";

export const getSignals = (category = "currencies") => {
  const param = typeof category === "number" ? `count=${category}` : `category=${encodeURIComponent(category || "currencies")}`;
  return api.get(`/signals?${param}`).then((r) => r.data);
};

export const refreshSignals = (category = "currencies") => {
  const param = typeof category === "string" ? `?category=${encodeURIComponent(category)}` : "";
  return api.post(`/signals/refresh${param}`).then((r) => r.data);
};

export const getSupportedPairs = () => api.get("/signals/pairs").then((r) => r.data);

